import { MenuActionTypes, MenuClickAction } from 'redux/menu/menuActions';

const isClickAction = (action: any): action is MenuClickAction =>
  action?.type === MenuActionTypes.CLICK;

export default isClickAction;
